import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { genStyleHooks, mergeToken } from '../../theme/internal';
var genStatisticStyle = function genStatisticStyle(token) {
  var componentCls = token.componentCls,
    marginXXS = token.marginXXS,
    padding = token.padding,
    colorTextDescription = token.colorTextDescription,
    titleFontSize = token.titleFontSize,
    colorTextHeading = token.colorTextHeading,
    contentFontSize = token.contentFontSize,
    fontFamily = token.fontFamily;
  return _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-title"), {
    marginBottom: marginXXS,
    color: colorTextDescription,
    fontSize: titleFontSize
  }), "".concat(componentCls, "-skeleton"), {
    paddingTop: padding
  }), "".concat(componentCls, "-content"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    color: colorTextHeading,
    fontSize: contentFontSize,
    fontFamily: fontFamily
  }, "".concat(componentCls, "-content-value"), {
    display: 'inline-block',
    direction: 'ltr'
  }), "".concat(componentCls, "-content-prefix, ").concat(componentCls, "-content-suffix"), {
    display: 'inline-block'
  }), "".concat(componentCls, "-content-prefix"), {
    marginInlineEnd: marginXXS
  }), "".concat(componentCls, "-content-suffix"), {
    marginInlineStart: marginXXS
  }))));
};
// ============================== Export ==============================
export var prepareComponentToken = function prepareComponentToken(token) {
  var fontSizeHeading3 = token.fontSizeHeading3,
    fontSize = token.fontSize;
  return {
    titleFontSize: fontSize,
    contentFontSize: fontSizeHeading3
  };
};
export default genStyleHooks('Statistic', function (token) {
  var statisticToken = mergeToken(token, {});
  return [genStatisticStyle(statisticToken)];
}, prepareComponentToken);